import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1 className='text-5xl text-center mt-20'>Your search Result is Not Found <span className='text-red-800 font-mono'>404</span></h1>

            <img className='mx-auto' src="https://m.media-amazon.com/images/I/51GMrV8lp-L._UY695_.jpg" alt="" />
        </div>
    );
};

export default NotFound;